import { checkboxColDefCreator, modifyButtonColDefCreator, stringColDefCreator } from "./standard-col-def-creators"
import { tContext } from "../types"

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const getCompanyHolidaySettings = () => {
    return {
        tableName: "Company Holidays",
        navId: "companyHolidays",
        resources: ["companyHolidays"],
        filters: [],
        colDefs: [
            checkboxColDefCreator({
                width: 60,
                headerCheckboxSelection: true,
            }),
            stringColDefCreator({
                headerName: "Name",
                maxLength: 100,
                width: 225,
                field: "/name",
            }),
            stringColDefCreator({
                headerName: "Description",
                field: "/description",
            }),
            {
                ...modifyButtonColDefCreator({
                    modifyFlow: "HOLIDAY_SETTINGS_MODIFY",
                    headerName: "Settings",
                    editable: true,
                }),
                field: "/settings",
                // Prevent AG-Grid from intercepting clicks meant for the Modify button
                editable: false,
                excludeFromExport: true,
            },
        ],
        gridSettings: {
            rowHeight: 40,
            defaultColDef: {
                editable: true,
                filter: true,
                sortable: false,
            },
            rowSelection: "multiple",
        },
        otherSettings: {
            hiddenColumnDefaults: {
                sort_order: {
                    value: 0,
                },
            },
            buttons: {
                cell: [],
                row: [
                    {
                        label: "Duplicate",
                        icon: "copy",
                        action: "duplicateRow",
                        // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
                        disabled: (context: tContext) =>
                            context.currentUser.employee.user_role !== "ADMIN" || context.selectedRows.length > 1,
                        // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
                        tooltip: (context: tContext) =>
                            context.currentUser.employee.user_role !== "ADMIN"
                                ? "Only Admins can perform this operation"
                                : context.selectedRows.length > 1
                                ? "You may only duplicate one row at a time"
                                : "Copy the selected company holiday set",
                    },
                    {
                        label: "Delete",
                        icon: "delete",
                        action: "deleteSelectedRows",
                        // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
                        disabled: (context: tContext) => context.currentUser.employee.user_role !== "ADMIN",
                        // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
                        tooltip: (context: tContext) =>
                            context.currentUser.employee.user_role !== "ADMIN"
                                ? "Only Admins can perform this operation"
                                : "Delete the selected company holiday set",
                    },
                ],
                table: [
                    {
                        label: "Create",
                        icon: "add",
                        action: "addCompanyHolidays",
                        // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
                        disabled: (context: tContext) => context.currentUser.employee.user_role !== "ADMIN",
                        // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
                        tooltip: (context: tContext) =>
                            context.currentUser.employee.user_role !== "ADMIN"
                                ? "Only Admins can perform this operation"
                                : "Create a new work rule set",
                    },
                ],
            },
        },
    }
}
